import apiFetch from '../../apiFetch'

export default function (paperworkId, token) {
  return apiFetch({ endPoint: `dossier/paperwork/${paperworkId}/modal`, method: 'GET', token: token })
}
